"use strict";

angular.module("vendor")
.controller("zoneSelectorModalController", function($scope, $attrs, close) {
    $scope.zones = $attrs.zones;

    this.close = function() {
        $scope.$element.modal("hide");
        $scope.$element.remove();
        close.apply(this, arguments);
    };

    this.cancel = function() {
        this.close();
    };

    this.updateZoneFilter = function() {
        this.close($scope.zones);
    };
});



//////////////////
// WEBPACK FOOTER
// ./vendor/app-core/zone-filter/zone-selector.modal.js
// module id = 825
// module chunks = 0